export * from "./Liberalism";
export * from "./Neoliberalism";
export * from "./Marxism";
export * from "./Anarchism";
export * from "./Positivism";

export const economicDoctrinesItems = {
  Liberalismo: {
    path: "/sociales/doctrinas-economicas/liberalismo",
  },
  Neoliberalismo: {
    path: "/sociales/doctrinas-economicas/neoliberalismo",
  },
  Marxismo: {
    path: "/sociales/doctrinas-economicas/marxismo",
  },
  Anarquismo: {
    path: "/sociales/doctrinas-economicas/anarquismo",
  },
  Positivismo: {
    path: "/sociales/doctrinas-economicas/positivismo",
  },
};
